import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { ActDomainManagmentFiltersForm } from 'civil-status/view-models/act-domain-managment-list';

export const transformDataset = (values: ActDomainManagmentFiltersForm): string => {
  const { page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    idDominio: {
      value: otherValues.domainType || '',
      operation: Operation.EQUALS,
    },
    nomeDominio: {
      value: otherValues.domainName || '',
      operation: Operation.LIKE,
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    page,
    rowsPerPage,
  })}`;
};
